module.exports = __webpack_public_path__ + "static/img/multiChartView-2.17640e1.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/multiChartView-2.svg
// module id = 8PiJ
// module chunks = 4